import { AnyAction } from '@reduxjs/toolkit'

import type { FetchStatusCommon } from 'restApi/types'
import type { Currency } from 'utils/currency'

const Suggestable = {
  listing: 'listing',
  story: 'story',
} as const

type VouchersState = FetchStatusCommon & {
  saving: boolean
  saved: boolean
  paying: boolean
  paid: boolean
  data?: {
    id: number
    from_name: string
    recipient_name: string
    recipient_email: string | null
    message: string
    amount: string
    theme: any
    suggestable: keyof typeof Suggestable
    currency: Currency
    story: {
      title: string
      promo_image?: {
        large: string
      }
    } | null
    listing: {
      title: string
      promo_image?: {
        large: string
      }
    } | null
    pdf_url: string | null
    user: {
      email: string
    }
  }
}

const initialState: VouchersState = {
  data: null,
  updating: false,
  updated: false,
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  paying: false,
  paid: false,
  error: null,
  submitting: false,
}

export default function reducer(
  state = initialState,
  action: AnyAction
): VouchersState {
  switch (action.type) {
    case 'VOUCHER_CREATE_PENDING':
      return {
        ...state,
        saving: true,
      }

    case 'VOUCHER_CREATE_REJECTED':
      return {
        ...state,
        saving: false,
        error: action.payload,
      }

    case 'VOUCHER_CREATE_FULFILLED':
      return {
        ...state,
        saving: false,
        saved: true,
        data: action.payload.data,
      }

    case 'VOUCHER_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'VOUCHER_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'VOUCHER_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }

    case 'VOUCHER_PAY_PENDING':
      return {
        ...state,
        paying: true,
      }

    case 'VOUCHER_PAY_REJECTED':
      return {
        ...state,
        paying: false,
        error: action.payload,
      }

    case 'VOUCHER_PAY_FULFILLED':
      return {
        ...state,
        paying: false,
        paid: true,
      }

    default:
      return state
  }
}
